import { useEffect, useMemo, useState } from 'react'
import { getServiceBaseUrl } from 'app/Utils/serviceUtils'
import stringToBool from 'app/Utils/stringToBool'
import { axiosWithCreds } from 'app/Utils/ajax.util'
import axios from 'axios'
import { readPersistentLocal, writePersistentLocal } from 'app/Store/storeUtils'

export const FLAGS = {
  LoneliestColor: 'loneliestColor',
  ShowMessage: 'showMessage',
  Recaptcha: 'grecaptchaEnabled',
  SiteSurveyEnabled: 'siteSurveyEnabled'
}

const LOCAL_FLAG_KEY = 'localFlags'

const setUpPersistentLocalFlags = () => {
  if (!readPersistentLocal(LOCAL_FLAG_KEY)) {
    writePersistentLocal(LOCAL_FLAG_KEY, {})
  }
}

setUpPersistentLocalFlags()

export const getFlagRequest = (flagName) => {
  const localFlags = readPersistentLocal(LOCAL_FLAG_KEY)
  const thisFlag = localFlags?.[flagName]

  if (typeof thisFlag !== 'undefined') {
    console.warn(`USING LOCAL FLAG OVERRIDE FOR ${flagName}`)
    return Promise.resolve({ data: { status: thisFlag } })
  }

  return axiosWithCreds.get(`${getServiceBaseUrl}/flags/${flagName}`)
}

const useFlag = (flagName) => {
  const [enabled, setEnabled] = useState(false)
  const [done, setDone] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  useEffect(() => {
    if (flagName) {
      setLoading(true)
      axios
        .all([
          getFlagRequest(flagName)
        ])
        .then(([flags]) => {
          const { status } = flags.data
          setEnabled(stringToBool(status))
        })
        .catch(err => {
          console.warn(`Error fetching flag: ${flagName}`, err)
          setError(true)
        })
        .then(() => {
          setLoading(false)
          setDone(true)
        })
    }
  }, [flagName])

  return useMemo(() => ({
    enabled,
    done,
    loading,
    error
  }), [enabled, done, loading, error])
}

export default useFlag
